import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './root.js';
import { isAuthenticated } from '../auth/AuthContext.js';

/**
 * Index route at `/` — bounces authenticated users to /dashboard,
 * unauthenticated to /login. No UI of its own.
 */
export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: isAuthenticated() ? '/dashboard' : '/login' });
  },
  component: () => null,
});
